import React from "react";
import { NonClearedBreakdownList } from "./NonClearedBreakdownList";
export const OnfidoConsider = ({ idStatus }) => {
    return React.createElement(NonClearedBreakdownList, { idStatus: idStatus });
};
